import React from 'react'
import { Icon, Grid, Card, Label, Popup, Dropdown } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom';
import { dispatch } from '@rematch/core';
import ImageAvater from '../../../../drive/Components/ImageAvater';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import PlaceholderExampleHeaderImage from '../../../../drive/PlaceHolder/PlaceHolderLoading';
import convertCamelCase from './../../../../../helpers/convert-camel-case'
class UserNameAndMemberDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.match.params.userId && this.props.managerList !== prevProps.managerList) {
            dispatch.users.getUserById(this.props.match.params.userId);
        }
    }
    gotToManager = async (data) => {
        this.props.history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/userDetail/${this.props.match.params.teamId}/Manager/${data._id}`);
        await dispatch.users.updateState(data);
        dispatch.app.showToolbar(false)
        dispatch.users.getUserById(data._id);

        let payL = {
            limit: 50,
            type: ['practices', 'initiatives', 'contents'],
            organizationId: this.props.match.params.workspaceId,
            teamId: this.props.match.params.teamId,
            userId: data._id
        }
        dispatch.notifications.getEventStreamForUserIdAndTeamId(payL);
        dispatch.notifications.getRecentUpdatesForTeamIdAndUserId({
            limit: 20,
            organizationId: this.props.match.params.workspaceId,
            teamId: this.props.match.params.teamId,
            userId: data._id
        });
    }

    render() {
        const { managerList } = this.props
        return (
            <Card className="w_100 mar_0" style={{ borderRadius: "0" }} >
                <Card.Content className="pad_0" >
                    <Grid celled='internally'>
                        <Grid.Row>

                            <Grid.Column style={{ width: "calc(100% - 300px)" }}>
                                {this.props.userObj ?
                                    <React.Fragment>
                                        <ImageAvater user={this.props.userObj} className="width_40 h_40" imageStyle="width_40 h_40" />
                                        <EllipsisTooltip
                                            name={<b>{this.props.userObj && this.props.userObj.firstName + " " + this.props.userObj.lastName}</b>}
                                            line={2}
                                            className="f_16"
                                        />

                                        {this.props.userObj && this.props.userObj.role ?
                                            <span style={{ marginLeft: "0 10px 0 0" }}>
                                                <Icon style={{ color: '#bdccd4' }} name="user" />
                                                {convertCamelCase(this.props.userObj.role)} </span> :
                                            null}
                                        <span ><Icon style={{ color: '#bdccd4' }} name="at" />{this.props.userObj && this.props.userObj.email}</span>
                                    </React.Fragment>
                                    :
                                    <PlaceholderExampleHeaderImage />}
                            </Grid.Column>
                            {this.props.match.params.workspaceId.toString() !== this.props.match.params.teamId.toString() ?
                                <Grid.Column style={{ width: "300px" }}>
                                    {managerList ?
                                        <div className="float-left">
                                            <div className="float-left" style={{ margin: "4px 0 0 0" }}>
                                                <label>{managerList.length > 1 ? ' Team Managers' : ' Team Manager'}</label>
                                                <Label size="small"  >{managerList.length}</Label>
                                            </div>
                                            <div className="float-left" style={{ margin: "0 20px" }}>
                                                {managerList && managerList.filter((i, index) => (index <= 4)).map((item, i) => {
                                                    return <Popup
                                                        key={i}
                                                        mouseEnterDelay={400}
                                                        inverted
                                                        className="popupStyled"
                                                        content={item.firstName + ' ' + item.lastName}
                                                        position={"bottom"}
                                                        trigger={
                                                            <div
                                                                onClick={() => this.gotToManager(item)}
                                                                className="float-left cursor-pointer"
                                                                style={{ position: "absolute", margin: `0 0 0 ${i * 24}px` }}
                                                            >
                                                                <ImageAvater user={item} className="width_30 h_30 " imageStyle="width_30 h_30 " />
                                                            </div>
                                                        }
                                                    >
                                                    </Popup>
                                                })}
                                                {managerList && managerList.length >= 5 ?
                                                    <div className="float-left" style={{ width: "20px", margin: `0 0 0 120px` }}>
                                                        <span className="memberCountInTeam">
                                                            {/* {managerList.length - 5} + */}
                                                            <Dropdown
                                                                text={<span style={{ padding: "0 5px" }}>+ {managerList.length - 5}</span>}
                                                                icon='none'
                                                                simple
                                                                direction="left"

                                                            >
                                                                <Dropdown.Menu>
                                                                    {managerList && managerList.filter((i, index) => (index > 4)).map((item, i) => (
                                                                        <div
                                                                            key={i}
                                                                            style={{ pointerEvents: "all" }}
                                                                            role="option"
                                                                            aria-checked="false"
                                                                            aria-selected="true"
                                                                            className="selected item"
                                                                            onClick={() => this.gotToManager(item)}
                                                                        >
                                                                            <img src={item.profilePic} className="ui avatar image" alt={item.firstName} />
                                                                            <span className="text" style={{ margin: "5px 0 0 0", display: "inline-flex" }}>{item.firstName + ' ' + item.lastName} </span>
                                                                        </div>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </span>
                                                    </div>
                                                    : null}
                                            </div>
                                        </div> :
                                        <PlaceholderExampleHeaderImage />
                                    }
                                </Grid.Column> : ''}
                        </Grid.Row>
                    </Grid>
                </Card.Content>

            </Card>
        )
    }
}
export default withRouter(UserNameAndMemberDetails);